<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZBtYyf/tc-custom/9781452170275.jpg?1729379484811" alt="This image is the cover for the book This Land is My Land"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">This Land is My Land
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times </i>bestselling author, “fascinating tales of intentional communities . . . and utopian visions . . . in a funny, enlightening graphic format” (<i>School Library Journal</i>).</b><br/>  <br/> Tired of your country’s bad politics? Feeling powerless to change things? Start your own utopia instead! This nonfiction graphic novel collects the stories of 30 self-made places around the world built with a dream of utopia, whether a safe haven, an inspiring structure, or a better-run country. These are the empowering and eccentric visions of creators who struck out against the laws of their homelands, the approval of their peers, and even nature itself to reshape the world around them.<br/>  <br/> Readers will travel around the globe, from the Gay and Lesbian Kingdom of the Coral Sea Islands to the Indian rock garden of Nek Chand, the micronation of Sealand to the pirate-founded, anti-slavery community of Libertatia.  Organized into five chapters: intentional communities, micronations, failed utopias, visionary environments, and strange dreams, <i>This Land is My Land </i>is infused with the hope that tomorrow will be better than today, a conviction universally depicted through the stories of people who were dissatisfied with the status quo and chose to build something better.<br/>  <br/> This informative, fun history makes a great coffee table book and conversation starter.<br/>  <br/> “Colorful fauvist drawings and maps...bring these would-be ‘better tomorrows’ to life with grace and verve.” —Martha Cornog, <i>Library Journal Xpress</i><br/>  <br/> “Rich, amusing. . . . [A] good example of what history comics can do.” —<i>The Beat</i><br/>  <br/> “Warner and Dam have infused these often-absurd stories with joy and a measure of dignity.” —NPR<br/>  <br/> Named a 2020 Great Graphic Novels for Teens by The Young Adult Services Association (YALSA).    
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andy Warner, Sofie Louise Dam
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?191deb44